// source: https://app.goflightlabs.com/ , https://gist.github.com/tdreyno/4278655

// filtered list from the one of the repo
export const icaoList = [
  "KABE",
  "KABQ",
  "YMAY",
  "EGPD",
  "YPAD",
  "SABE",
  "LEMG",
  "KAGS",
  "NZAA",
  "KALB",
  "LEAL",
  "EHAM",
  "PANC",
  "KAPA",
  "ESSA",
  "KATL",
  "KATW",
  "TNCA",
  "KAUS",
  "KIWA",
  "LEBL",
  "KBDR",
  "OLBA",
  "KBFI",
  "EGAA",
  "TBPB",
  "ENBR",
  "LIME",
  "EGBB",
  "KBIS",
  "KBLI",
  "LIPE",
  "KBMI",
  "KBNA",
  "YBBN",
  "LFBD",
  "KBOI",
  "KBOS",
  "KBOW",
  "LIBD",
  "KBRO",
  "EGGD",
  "SBBR",
  "KBTR",
  "LZIB",
  "LHBP",
  "KBUF",
  "KBUR",
  "KBWI",
  "YSCB",
  "LFPG",
  "KCDW",
  "SBSP",
  "EDDK",
  "KCHA",
  "NZCH",
  "KCRQ",
  "KCLT",
  "KCMH",
  "KCMI",
  "KCOS",
  "EKCH",
  "KCVG",
  "KCWA",
  "KCYS",
  "KDAB",
  "KDAL",
  "KDAY",
  "KDCA",
  "VIDP",
  "KDEN",
  "KDFW",
  "KDTW",
  "EIDW",
  "KDUJ",
  "KDVO",
  "EGPH",
  "EGNX",
  "PAEN",
  "LTAC",
  "KORS",
  "KEUG",
  "KEWB",
  "KEWR",
  "LPFR",
  "KFAR",
  "KFAY",
  "LIRF",
  "KFLL",
  "LPMA",
  "KFNL",
  "EPGD",
  "SBGL",
  "EGPF",
  "KGNV",
  "KGPI",
  "LSGG",
  "VVNB",
  "EFHK",
  "NZHN",
  "KHND",
  "KHOU",
  "KHPN",
  "KHRL",
  "KHSV",
  "KHVN",
  "KIAD",
  "KIAH",
  "KIND",
  "KINT",
  "KISP",
  "NZNV",
  "KJFK",
  "KJNX",
  "RJBB",
  "EPKK",
  "EPKT",
  "KLAS",
  "KLAX",
  "KLBB",
  "KLBE",
  "LCLK",
  "ULLI",
  "EDDP",
  "KLGA",
  "EGLL",
  "EGGP",
  "EGGW",
  "ELLX",
  "LEMD",
  "EGCC",
  "KMCI",
  "KMCO",
  "KMCW",
  "KMDT",
  "KMDW",
  "YMML",
  "KMGM",
  "KMHR",
  "KMHT",
  "KMIA",
  "KMKC",
  "KMKE",
  "KMLB",
  "KMMK",
  "RPLL",
  "KMOD",
  "LFML",
  "KMRY",
  "KMSN",
  "KMSP",
  "KMSY",
  "EDDM",
  "KMVY",
  "LIMC",
  "LFMN",
  "EGNT",
  "RJAA",
  "LFRS",
  "KOAK",
  "KOKC",
  "KOMA",
  "KONT",
  "YBCG",
  "KOPF",
  "LPPR",
  "KORD",
  "EICK",
  "LFPO",
  "LROP",
  "KOXR",
  "KPBI",
  "KPDX",
  "KPHL",
  "KPHX",
  "KPIE",
  "KPMD",
  "LEPA",
  "NZPM",
  "KPNS",
  "NTAA",
  "LIRP",
  "KPSP",
  "KPWK",
  "KRDU",
  "KRIC",
  "EVRA",
  "KRNO",
  "KROC",
  "NZRO",
  "EHRD",
  "KSAN",
  "KSAT",
  "KSAV",
  "LTFJ",
  "KSBP",
  "KSBY",
  "KSCK",
  "KSDF",
  "KSDL",
  "MDSD",
  "KSEA",
  "KSFB",
  "KSFO",
  "KSGF",
  "TJIG",
  "KSJC",
  "TJSJ",
  "KSLC",
  "LPAZ",
  "KSMX",
  "KSNA",
  "KSNC",
  "EINN",
  "KSPB",
  "KSPI",
  "KSRQ",
  "KSTL",
  "EGSS",
  "KSTS",
  "UUEE",
  "LEZL",
  "KSWF",
  "EDDB",
  "YSSY",
  "KSYR",
  "KTEB",
  "KTLH",
  "LFBO",
  "LLBG",
  "KTPA",
  "NZTG",
  "KTRK",
  "KTTA",
  "KTUL",
  "KTUS",
  "KTYS",
  "LIPZ",
  "SBKP",
  "KVCT",
  "LOWW",
  "SBVT",
  "UUWW",
  "EPWA",
  "NZWN",
  "CYCD",
  "CYHM",
  "CYHZ",
  "CYKA",
  "CYOW",
  "CYTZ",
  "CYUL",
  "CYVR",
  "CYWG",
  "CYXX",
  "CYYC",
  "CYYJ",
  "CYYZ",
  "LSZH",
];

// raw list from the repo
export const icaoFirstList = [
  "NTGA",
  "DABB",
  "EKYT",
  "FAMD",
  "OMAL",
  "URKA",
  "EKAH",
  "ZWAT",
  "SBAX",
  "OYGD",
  "UNAA",
  "LEAB",
  "OIAA",
  "KABE",
  "KABI",
  "DIAP",
  "HAKD",
  "YBAM",
  "KABQ",
  "KABR",
  "HEBL",
  "OEBA",
  "DNAA",
  "YMAY",
  "KABY",
  "EGPD",
  "MMAA",
  "DGAA",
  "GCRR",
  "LSZR",
  "EGJA",
  "KACK",
  "KACP",
  "KACT",
  "KACV",
  "KACY",
  "KACZ",
  "LTAF",
  "LTBJ",
  "HAAB",
  "OYAA",
  "LTAG",
  "OJAM",
  "PADK",
  "YPAD",
  "PADQ",
  "OITL",
  "EGQL",
  "SKSP",
  "FTTC",
  "SABE",
  "URSS",
  "ENAL",
  "KAEX",
  "BIAR",
  "SAMR",
  "SBAT",
  "GMAD",
  "LFBA",
  "ESTA",
  "BGAM",
  "PAGN",
  "LEMG",
  "VIAG",
  "KAGS",
  "SGES",
  "MMAS",
  "SVAC",
  "VOAT",
  "OEAB",
  "KAHC",
  "LIEA",
  "GMTA",
  "KAIA",
  "PAWT",
  "NCAI",
  "NCAT",
  "LFKJ",
  "OESK",
  "LTCO",
  "VEAZ",
  "FMCV",
  "ESNX",
  "SBAR",
  "ZLAK",
  "HLKF",
  "RJEC",
  "PAKH",
  "NZAA",
  "PAKN",
  "PAKP",
  "FAKS",
  "ZWAK",
  "CYKO",
  "UATT",
  "VYSW",
  "UAAA",
  "KALB",
  "LEAL",
  "ENAT",
  "DAAG",
  "YABA",
  "KALM",
  "KALO",
  "OSAP",
  "KALS",
  "KALW",
  "HEAX",
  "KAMA",
  "VAAH",
  "HAAM",
  "WRRA",
  "OJAI",
  "WAPP",
  "EHAM",
  "ULDD",
  "PANC",
  "LFRA",
  "SCFA",
  "LFBU",
  "PANI",
  "FMNH",
  "EBAW",
  "TAPA",
  "PANV",
  "ENAN",
  "EDAC",
  "LIPY",
  "RJSA",
  "LGKP",
  "KAOO",
  "WMKA",
  "KAPA",
  "KAPF",
  "NTGD",
  "FQNP",
  "KAPN",
  "NSFA",
  "ZSAQ",
  "OJAQ",
  "SPQU",
  "PARC",
  "ULAA",
  "SCAR",
  "HTAR",
  "YARM",
  "ESSA",
  "KART",
  "SBAU",
  "KARV",
  "LRAR",
  "HHSB",
  "UTAA",
  "MYAF",
  "KASE",
  "URWA",
  "FHAW",
  "RJKA",
  "HHAS",
  "HASO",
  "YBAS",
  "LTAU",
  "SGAS",
  "HKAM",
  "HESN",
  "HSAT",
  "MYCA",
  "LGAV",
  "PATQ",
  "KATL",
  "SBHT",
  "VIAR",
  "GQPA",
  "KATW",
  "KATY",
  "HEAT",
  "TNCA",
  "SKUC",
  "KAUG",
  "OMAA",
  "LFLW",
  "KAUS",
  "KAVL",
  "LFMV",
  "KAVP",
  "YMAV",
  "NVVB",
  "OIAW",
  "TQPF",
  "LGAL",
  "SKAR",
  "MYAP",
  "NTGU",
  "RJSK",
  "HAAX",
  "YAYE",
  "LTAI",
  "KIWA",
  "OIYY",
  "UTKA",
  "KAZO",
  "DAUA",
  "MDEP",
  "RPUB",
  "OBBI",
  "LTCJ",
  "SKBQ",
  "SBBU",
  "KBAX",
  "LRBM",
  "VEBS",
  "FBKE",
  "LRBS",
  "RPVB",
  "YBAR",
  "LRBC",
  "LEBL",
  "TXKF",
  "WRBB",
  "KBDL",
  "WICC",
  "VABO",
  "KBDR",
  "LIBR",
  "ENDU",
  "LYBE",
  "SBBE",
  "HLLB",
  "LFRB",
  "PABE",
  "FQBR",
  "OLBA",
  "KBFD",
  "KBFE",
  "KBFF",
  "KBFI",
  "KBFL",
  "FABL",
  "EGAA",
  "SKBG",
  "FEFF",
  "TBPB",
  "KBGM",
  "ENBR",
  "KBGR",
  "LIME",
  "KBHB",
  "EGAC",
  "NZWB",
  "VABJ",
  "UTSB",
  "KBHM",
  "VABP",
  "YBHI",
  "OPBW",
  "EGBB",
  "LFKB",
  "KBID",
  "KBIL",
  "MYBS",
  "LEBB",
  "LFBZ",
  "KBIS",
  "ENBS",
  "KBJI",
  "GBYD",
  "HBBA",
  "MMLO",
  "LEBZ",
  "WBKK",
  "VTBS",
  "KBKL",
  "GABS",
  "KBKS",
  "KBKW",
  "SVBC",
  "KBLI",
  "EGNH",
  "EKBI",
  "LIPE",
  "VOBG",
  "KBLV",
  "FWCL",
  "ESSB",
  "KBMI",
  "KBNA",
  "YBBN",
  "YBNA",
  "ENBN",
  "SVBI",
  "LQBK",
  "NTTB",
  "LFBD",
  "SKBO",
  "EGHH",
  "KBOI",
  "LBBG",
  "VABB",
  "TNCB",
  "ENBO",
  "KBOS",
  "KBOW",
  "DFOO",
  "WALL",
  "SBPS",
  "KBPT",
  "KBQK",
  "TJBQ",
  "SAZS",
  "KBRD",
  "EDDW",
  "LIBD",
  "KBRL",
  "SVBM",
  "LSZB",
  "KBRO",
  "LKTB",
  "EGPR",
  "EGGD",
  "EBBR",
  "PABR",
  "HCMF",
  "SBBR",
  "DAUB",
  "LFSB",
  "PABA",
  "KBTL",
  "KBTM",
  "KBTR",
  "LZIB",
  "PABT",
  "WBGB",
  "KBTV",
  "AYBK",
  "YBKT",
  "LHBP",
  "KBUF",
  "SKBU",
  "HCMV",
  "FVBU",
  "KBUR",
  "UGSB",
  "FZKA",
  "OIBB",
  "LFOB",
  "SBBV",
  "YBDV",
  "VNBW",
  "EDVE",
  "EGNL",
  "KBWI",
  "WBSB",
  "RPME",
  "MZBZ",
  "EPBD",
  "VGBR",
  "KBZN",
  "LIPB",
  "LFMU",
  "FCBB",
  "EGVN",
  "KCAE",
  "KCAG",
  "HECA",
  "KCAK",
  "ZGGG",
  "SOCA",
  "SLCB",
  "EGSC",
  "YSCB",
  "LFMK",
  "VOCL",
  "SCIE",
  "SVMI",
  "VECC",
  "PACD",
  "KCDC",
  "LFPG",
  "KCDR",
  "PACV",
  "KCDW",
  "RPVM",
  "KCEC",
  "VTCT",
  "KCEK",
  "MMCN",
  "KCEZ",
  "LFLC",
  "EIDL",
  "LFRK",
  "KCFS",
  "LGKR",
  "SBCY",
  "SBSP",
  "KCGI",
  "WIII",
  "EDDK",
  "ZHCC",
  "VGEG",
  "ZYCC",
  "SBCG",
  "KCHA",
  "NZCH",
  "KCHO",
  "LGSA",
  "KCHS",
  "KCHT",
  "KCHU",
  "LIRA",
  "KCIC",
  "KCID",
  "KCIU",
  "SPHI",
  "KCJJ",
  "MMCS",
  "RKPC",
  "KCKB",
  "GUCY",
  "KCRQ",
  "KCLE",
  "LRCL",
  "KCLL",
  "KCLM",
  "SKCL",
  "MMIA",
  "KCLT",
  "LFKC",
  "YCMU",
  "VCBI",
  "MMCE",
  "LFLB",
  "SBCR",
  "KCMH",
  "KCMI",
  "GMMN",
  "KCMX",
  "KCNC",
  "LRCK",
  "SBCF",
  "KCNM",
  "KCNP",
  "YBCS",
  "VTCC",
  "KCNY",
  "KCOD",
  "VOCC",
  "DBBB",
  "KCOQ",
  "SACO",
  "KCOS",
  "KCOU",
  "SAMI",
  "MMCP",
  "EKCH",
  "KCPR",
  "FACT",
  "SBKG",
  "TJCP",
  "LRCV",
  "SAVC",
  "RPLC",
  "EBCI",
  "KCRP",
  "KCRW",
  "KCSG",
  "ZGHA",
  "UWKS",
  "LICC",
  "SKCG",
  "MMCM",
  "RJCC",
  "ZUUU",
  "SKCC",
  "SECU",
  "MMCL",
  "SVCU",
  "MMUN",
  "SVCP",
  "TNCC",
  "MMCU",
  "SPZO",
  "KCVG",
  "MMCV",
  "KCVN",
  "EGBE",
  "KCWA",
  "SBCT",
  "EGFF",
  "CYHC",
  "MWCB",
  "KCYO",
  "KCYS",
  "KCZL",
  "MMCZ",
  "KDAB",
  "VGZR",
  "VVDN",
  "KDAL",
  "OSDI",
  "HTDA",
  "KDAY",
  "YSDU",
  "KDBQ",
  "LDDU",
  "KDCA",
  "TDCF",
  "LFCK",
  "KDDC",
  "KDEC",
  "VIDN",
  "VIDP",
  "KDEN",
  "OSDZ",
  "KDFW",
  "YMDG",
  "MMDO",
  "RPVD",
  "KDHN",
  "VEMN",
  "FMNA",
  "KDIK",
  "WPDL",
  "HADR",
  "VA1P",
  "LTCC",
  "WIPA",
  "DTTJ",
  "DAAJ",
  "WAJJ",
  "GOOY",
  "FKKD",
  "KDLC",
  "PADL",
  "KDLH",
  "LTBS",
  "KDLZ",
  "UUDD",
  "VTBD",
  "OEDF",
  "VEMR",
  "EGPN",
  "UKDD",
  "LFRD",
  "HSDN",
  "OTBD",
  "UKCC",
  "TDPD",
  "RPMG",
  "YDPO",
  "WADD",
  "KDRO",
  "EDDC",
  "KDRT",
  "YPDN",
  "EGCN",
  "KDSM",
  "EDLW",
  "KDTW",
  "EIDW",
  "NZDN",
  "KDUJ",
  "FADN",
  "EDDL",
  "PADU",
  "KDVL",
  "KDVO",
  "OMDB",
  "UTDD",
  "FMCZ",
  "UAKD",
  "PAEA",
  "KEAR",
  "KEAT",
  "KEAU",
  "HUEN",
  "EKEB",
  "ORER",
  "LCEN",
  "EGPH",
  "LFBE",
  "KEGE",
  "KEGV",
  "PAII",
  "EHEH",
  "TUPJ",
  "SKEJ",
  "KEKO",
  "KELM",
  "KELP",
  "FAEL",
  "KELY",
  "EGNX",
  "PAEN",
  "EHTW",
  "KENW",
  "SKMD",
  "YESP",
  "EDDE",
  "KERI",
  "FYWE",
  "LTAC",
  "KESC",
  "KORS",
  "LLET",
  "KEUG",
  "ENEV",
  "UDYZ",
  "KEVV",
  "KEWB",
  "KEWN",
  "KEWR",
  "EGTE",
  "KEYW",
  "SAEZ",
  "EKVG",
  "PAFA",
  "LPFR",
  "KFAR",
  "KFAT",
  "KFAY",
  "KFCA",
  "LIRF",
  "ENBL",
  "TFFF",
  "EDNY",
  "FZAA",
  "OMFJ",
  "EDSB",
  "KFKL",
  "KFKS",
  "KFLG",
  "KFLL",
  "KFLO",
  "LIRQ",
  "KFMN",
  "EDDG",
  "KFMY",
  "GFLL",
  "LPMA",
  "LFTW",
  "ZKPY",
  "KFNL",
  "KFNT",
  "KFOD",
  "SBFZ",
  "MYGF",
  "EDDF",
  "KFHR",
  "LIPK",
  "ENFL",
  "MGTK",
  "UAFM",
  "LFKF",
  "KFSD",
  "KFSM",
  "LFVP",
  "GCFV",
  "RJFF",
  "NGFU",
  "KFWA",
  "PFYU",
  "KGAF",
  "PAGA",
  "PAGM",
  "VRMG",
  "KGAO",
  "VEGT",
  "VEGY",
  "KGBD",
  "FBSK",
  "KGCC",
  "EGJB",
  "KGCK",
  "MWCR",
  "MMGL",
  "EPGD",
  "KGEG",
  "SYCJ",
  "KGEV",
  "KGFK",
  "KGGG",
  "SBGL",
  "NZGS",
  "KGJT",
  "EGPF",
  "KGLH",
  "EGBJ",
  "RKSS",
  "KGNB",
  "TGPY",
  "KGNV",
  "LIMJ",
  "BGGH",
  "KGOP",
  "ESGG",
  "KGOV",
  "LGRX",
  "KGPI",
  "KGPT",
  "KGRB",
  "FAGG",
  "KGRK",
  "LEGE",
  "EHGG",
  "KGRR",
  "SBGR",
  "LOWG",
  "ESGP",
  "KGSO",
  "KGSP",
  "PAGS",
  "KGTE",
  "KGTF",
  "KGTR",
  "MGGT",
  "KGUC",
  "PGUM",
  "LSGG",
  "EICM",
  "UBBB",
  "SEGU",
  "KGYL",
  "MMGM",
  "KHAD",
  "KHAE",
  "FMCH",
  "EDDV",
  "EDDH",
  "VVNB",
  "VRMH",
  "ENHD",
  "MUHA",
  "YMHB",
  "EDIU",
  "KHDN",
  "VTSS",
  "KHEI",
  "EFHK",
  "LGIR",
  "ZBHH",
  "ENHF",
  "ZSHC",
  "EDFH",
  "KHIB",
  "RJCH",
  "VHHH",
  "NZHK",
  "VTSP",
  "KHLN",
  "NZHN",
  "MMHO",
  "KHND",
  "PAOH",
  "PHNL",
  "PHHN",
  "PAHN",
  "KHOB",
  "KHOE",
  "MUHG",
  "PAHO",
  "KHON",
  "EDQM",
  "KHOU",
  "ENOV",
  "PAHP",
  "KHPN",
  "ZYHB",
  "FVHA",
  "HEGN",
  "UKHH",
  "KHRL",
  "KHRT",
  "KHSV",
  "YBHM",
  "KHTS",
  "RCYU",
  "ENHV",
  "KHVN",
  "KHVR",
  "KHYA",
  "VOHY",
  "KHYS",
  "KIAD",
  "KIAG",
  "KIAH",
  "PAIK",
  "LRIA",
  "LEIB",
  "RKSI",
  "KICT",
  "KIDA",
  "VAID",
  "EPZG",
  "UKKK",
  "KIFP",
  "PAIG",
  "KIGM",
  "SBFI",
  "OIIE",
  "PAKO",
  "UUII",
  "PAIL",
  "KILM",
  "KILN",
  "KIMT",
  "KIND",
  "KINL",
  "LOWI",
  "KINT",
  "ANYN",
  "LGIO",
  "EGNS",
  "WMKI",
  "KIPL",
  "KIPT",
  "EGSE",
  "SCDA",
  "SPQT",
  "KISB",
  "KISN",
  "KISO",
  "KISP",
  "LTBA",
  "KITH",
  "RJOO",
  "PHTO",
  "NIUE",
  "NZNV",
  "EFIV",
  "YIVL",
  "KIWD",
  "VEAT",
  "VEBD",
  "VICG",
  "VIAL",
  "VOML",
  "VABM",
  "VELR",
  "VIJU",
  "VILH",
  "VOMD",
  "VERC",
  "VEKU",
  "VAAU",
  "VEJS",
  "VAKE",
  "VOPB",
  "KIYK",
  "KJAC",
  "VIJP",
  "KJAN",
  "KJAX",
  "OEJN",
  "KJEF",
  "KJER",
  "KJFK",
  "PHJH",
  "KJHW",
  "HDAM",
  "HAJJ",
  "HAJM",
  "ZSJJ",
  "ZBDX",
  "BGQE",
  "LGHI",
  "KJKL",
  "KJLN",
  "KJMS",
  "FAJS",
  "PAJN",
  "KJNX",
  "EFJO",
  "SBJP",
  "KJRB",
  "VEJT",
  "HTKJ",
  "KJST",
  "SASJ",
  "SPJL",
  "BGUK",
  "ZUJZ",
  "KJYR",
  "OSKL",
  "PAKV",
  "NZKT",
  "OAKB",
  "UKBB",
  "PAJC",
  "EEKA",
  "BIKF",
  "HRYR",
  "LGKO",
  "RCKH",
  "OPKC",
  "RJSN",
  "FAKM",
  "MKJP",
  "EIKY",
  "LUKK",
  "RJBB",
  "UNKL",
  "PAKK",
  "NZKK",
  "ENKR",
  "PALG",
  "LOWK",
  "LKKV",
  "ZPPP",
  "RJFT",
  "PANW",
  "PHKO",
  "RJFK",
  "PAPC",
  "EPKK",
  "EKKA",
  "ENCN",
  "LZKZ",
  "OICC",
  "PASM",
  "EKSN",
  "ENKB",
  "PAKT",
  "EPKT",
  "WMKK",
  "PAVL",
  "OKBK",
  "NFNO",
  "PAKY",
  "LGKZ",
  "KLAN",
  "MMLP",
  "KLAR",
  "KLAS",
  "KLAW",
  "KLAX",
  "EGNM",
  "KLBB",
  "KLBE",
  "KLBF",
  "KLBL",
  "FOOL",
  "LCLK",
  "LECO",
  "KLCH",
  "EPLL",
  "KLCK",
  "EGLC",
  "LFBT",
  "EGAE",
  "YPLM",
  "KLEB",
  "ULLI",
  "LFOH",
  "LEAM",
  "EDDP",
  "KLEX",
  "KLFT",
  "DXXX",
  "KLGA",
  "EBLG",
  "OPLA",
  "EGLL",
  "KLHW",
  "LFBL",
  "PHLI",
  "SPIM",
  "LIML",
  "MRLB",
  "LPPT",
  "KLIT",
  "LJLJ",
  "ENNA",
  "ESPA",
  "KLLU",
  "MMLM",
  "LICD",
  "KLMT",
  "KLNK",
  "PHNY",
  "DNMM",
  "KLOU",
  "MMMV",
  "SLLP",
  "ESSL",
  "EGGP",
  "EFLP",
  "KLRD",
  "YLRE",
  "MDLR",
  "LFRH",
  "KLSE",
  "YMLT",
  "EGGW",
  "MMLT",
  "KLUD",
  "KLUF",
  "KLUG",
  "KLUM",
  "FLLS",
  "PHLU",
  "PALU",
  "ELLX",
  "KLWB",
  "UDSG",
  "UKLL",
  "KLWS",
  "KLWT",
  "ZULS",
  "KLYH",
  "ENSB",
  "LFLL",
  "MMLC",
  "VOMM",
  "LEMD",
  "KMAF",
  "MMMA",
  "EGCC",
  "KMAO",
  "SVMC",
  "TJMZ",
  "HKMO",
  "MKJS",
  "KMBL",
  "KMBS",
  "KMBT",
  "KMCE",
  "PAMC",
  "KMCI",
  "KMCK",
  "KMCN",
  "KMCO",
  "OOMS",
  "KMCW",
  "KMCX",
  "YBMC",
  "KMCZ",
  "SKRG",
  "KMDQ",
  "KMDS",
  "KMDT",
  "KMDW",
  "KMDZ",
  "KMEI",
  "YMML",
  "KMEM",
  "WIMM",
  "MMMX",
  "KMEY",
  "KMFE",
  "VMMC",
  "KMFR",
  "MNMG",
  "KMGM",
  "KMGW",
  "KMHK",
  "KMHP",
  "KMHR",
  "KMHT",
  "KMIA",
  "MMMD",
  "KMJD",
  "HLLM",
  "LELC",
  "KMKC",
  "KMKE",
  "KMKG",
  "PHMK",
  "YBMK",
  "LMML",
  "KMLB",
  "KMLE",
  "LFSB",
  "KMLI",
  "MMMM",
  "KMLU",
  "PAML",
  "EGNV",
  "KMMH",
  "KMMK",
  "ESMS",
  "KMNF",
  "RPLL",
  "KMOB",
  "KMOD",
  "ENML",
  "KMOT",
  "PAMO",
  "LFMT",
  "EGYP",
  "YMIA",
  "KSAW",
  "LFML",
  "FIMP",
  "URMM",
  "KMRY",
  "GMSH",
  "KMSL",
  "KMSN",
  "KMSO",
  "KMSP",
  "UMMS",
  "KMSS",
  "EHBK",
  "KMSY",
  "KMTJ",
  "MMMT",
  "KMTV",
  "MMMY",
  "EDDM",
  "PHMU",
  "SUMU",
  "KMVY",
  "KMWA",
  "MMML",
  "LIMC",
  "KMYJ",
  "KMYL",
  "KMYR",
  "PAMY",
  "KMZH",
  "MMMZ",
  "NFFN",
  "LIRN",
  "MYNN",
  "SBNT",
  "KNBC",
  "HKJK",
  "KNCA",
  "LFMN",
  "EGNT",
  "LFLP",
  "FTTJ",
  "TKPN",
  "RJGG",
  "KNGS",
  "DRRN",
  "KNIP",
  "GQNN",
  "ZSNG",
  "RJNA",
  "MMNL",
  "YNSF",
  "EIKN",
  "NWWW",
  "NZNR",
  "NZNP",
  "EGDG",
  "KNRA",
  "KNRN",
  "RJAA",
  "KNSI",
  "NZNS",
  "LFRS",
  "YWLM",
  "EDDN",
  "KNUI",
  "PANU",
  "ENNK",
  "EGSH",
  "ESKN",
  "KOAJ",
  "KOAK",
  "NZOU",
  "MMOX",
  "UKOO",
  "KOKH",
  "ESNO",
  "PHOG",
  "KOGS",
  "LWOH",
  "RJFO",
  "ROAH",
  "KOKC",
  "RJOB",
  "KOLF",
  "KOMA",
  "PAOM",
  "KOMH",
  "LROD",
  "KONL",
  "KONT",
  "PAOO",
  "YBCG",
  "KOPF",
  "LPPR",
  "KORB",
  "KORD",
  "KORF",
  "KORH",
  "EICK",
  "EGBK",
  "LFPO",
  "ENGM",
  "LKMT",
  "KOTH",
  "LROP",
  "PAOT",
  "DFFD",
  "GMFO",
  "EFOU",
  "GQPZ",
  "UNNT",
  "LEAS",
  "KOVS",
  "KOXB",
  "KOXR",
  "EDLP",
  "KPAH",
  "MTPP",
  "LGPA",
  "VEPT",
  "MMPA",
  "MMPB",
  "KPBG",
  "KPBH",
  "KPBI",
  "SMJP",
  "YPBO",
  "SPCL",
  "WIPT",
  "LPPD",
  "SULS",
  "MMPG",
  "KPDT",
  "KPDX",
  "LKPD",
  "SKPE",
  "ZBAA",
  "SPTU",
  "WMKP",
  "YPPH",
  "OPPS",
  "KPEX",
  "KPEZ",
  "KPFN",
  "LCPH",
  "KPGA",
  "LFMP",
  "OIBI",
  "KPGV",
  "LFBX",
  "DNPO",
  "YPPD",
  "KPHF",
  "KPHG",
  "KPHL",
  "PAPO",
  "KPHX",
  "KPIA",
  "KPIB",
  "KPIE",
  "KPIH",
  "EGPK",
  "KPIR",
  "LFBI",
  "KPIT",
  "SPUR",
  "PPIZ",
  "OPPG",
  "KPKB",
  "UHPP",
  "WIBB",
  "KPLD",
  "EGHD",
  "WIPP",
  "KPLN",
  "EYPA",
  "MBPV",
  "SBBH",
  "FAPE",
  "SCTE",
  "KPMD",
  "LIMP",
  "LEPA",
  "LICJ",
  "NZPM",
  "KPMV",
  "SAVY",
  "KPMZ",
  "KPNA",
  "VDPP",
  "WIOO",
  "PAPN",
  "FCPP",
  "KPNS",
  "SBPA",
  "FOOG",
  "AYPY",
  "MDPP",
  "EFPO",
  "TTPP",
  "EPPO",
  "NSTU",
  "RPVP",
  "NTAA",
  "KPQI",
  "KPRC",
  "KPRG",
  "KPRN",
  "LIRP",
  "KPSC",
  "TJPS",
  "PAPG",
  "KPSP",
  "LIBP",
  "SARP",
  "PAPH",
  "TFFR",
  "PAPM",
  "MPTO",
  "KPUB",
  "LFBP",
  "MDPC",
  "SCCI",
  "RKPP",
  "KPUW",
  "LDPL",
  "KPVC",
  "KPVD",
  "KPVG",
  "LGPZ",
  "MMPR",
  "KPWK",
  "KPWM",
  "MMPS",
  "LPPS",
  "SVPR",
  "DNIM",
  "LFMA",
  "GMMX",
  "KRAP",
  "NCRG",
  "KRAS",
  "GMME",
  "PARY",
  "PADG",
  "KRDD",
  "KRDM",
  "KRDU",
  "SBRF",
  "VDSR",
  "LERS",
  "MMRX",
  "KRFD",
  "VYYY",
  "KRHI",
  "LGRP",
  "KRIA",
  "KRIC",
  "KRIV",
  "KRIW",
  "EVRA",
  "KRKD",
  "KRKS",
  "OMRK",
  "BIRK",
  "ETNL",
  "LIPR",
  "EKRN",
  "KRNO",
  "KRNP",
  "LFRN",
  "KROA",
  "KROC",
  "KBRK",
  "PGRO",
  "PTRO",
  "KROS",
  "NZRO",
  "KROW",
  "VARP",
  "ENRO",
  "PARS",
  "KRST",
  "KRSW",
  "MHRO",
  "EHRD",
  "OERK",
  "FMEE",
  "KRUT",
  "EFRO",
  "ENRY",
  "EPRZ",
  "OYSN",
  "MSLP",
  "KSAN",
  "MHLM",
  "KSAT",
  "KSAV",
  "LTFJ",
  "KSBA",
  "KSBN",
  "KSBP",
  "KSBY",
  "LRSB",
  "PASC",
  "KUNV",
  "KSCK",
  "SCEL",
  "EDDR",
  "LEST",
  "MUCU",
  "LRSV",
  "KSCX",
  "KSDF",
  "RJSS",
  "KSDL",
  "ENSD",
  "PASD",
  "MDSD",
  "SBRJ",
  "KSDY",
  "KSEA",
  "FSIA",
  "KSFB",
  "KSFD",
  "KSFO",
  "EKSB",
  "KSGF",
  "VVTS",
  "KSGU",
  "PAGY",
  "ZSSS",
  "KSHD",
  "ZYTX",
  "PAHG",
  "PASH",
  "KSHL",
  "KSHR",
  "KSHV",
  "GVAC",
  "TJIG",
  "WSSS",
  "PASI",
  "KSJC",
  "MMSD",
  "LQSA",
  "MROC",
  "KSJT",
  "TJSJ",
  "TKPK",
  "ENSN",
  "LGTS",
  "ENSK",
  "LWSK",
  "SASA",
  "KSLC",
  "KSLE",
  "KSLH",
  "KSLI",
  "KSLK",
  "KSLN",
  "PASL",
  "TLPC",
  "MMIO",
  "LPAZ",
  "KSMF",
  "KSMN",
  "KSMS",
  "KSMX",
  "KSNA",
  "KSNC",
  "EINN",
  "PASN",
  "LBSF",
  "EGHI",
  "PASO",
  "KSOW",
  "KSPB",
  "GCLA",
  "KSPI",
  "PGSN",
  "KSPS",
  "LDSP",
  "KSRE",
  "WARS",
  "ENSA",
  "KSRQ",
  "SBSV",
  "FGSL",
  "HESH",
  "KSTC",
  "MDST",
  "KSTL",
  "EGSS",
  "EDDS",
  "KSTS",
  "TIST",
  "TISX",
  "WARR",
  "LICA",
  "LRSM",
  "KSUN",
  "KSUX",
  "PASA",
  "KSVC",
  "TVSV",
  "ENZV",
  "UUEE",
  "LEZL",
  "USSS",
  "KSWF",
  "KSWO",
  "EGFH",
  "LFST",
  "EDDB",
  "EISG",
  "TNCM",
  "YSSY",
  "KSYR",
  "EGPO",
  "OISS",
  "WMSA",
  "EGSY",
  "TTCP",
  "PATA",
  "MMTM",
  "ZSQD",
  "MMTP",
  "UTTT",
  "LZTT",
  "KTBN",
  "UGTB",
  "NFTF",
  "OITT",
  "KTEB",
  "LPLA",
  "KTEX",
  "GCXO",
  "GCTS",
  "KTGC",
  "LYPG",
  "LRTM",
  "MHTG",
  "MMTG",
  "EDDI",
  "OIII",
  "BGTL",
  "LATI",
  "KTIF",
  "MMTJ",
  "HLLT",
  "NZTU",
  "LYTV",
  "SLTJ",
  "PATJ",
  "EFTU",
  "KTKV",
  "KTKX",
  "PATE",
  "MMTO",
  "KTLH",
  "PATL",
  "EETN",
  "LFBO",
  "LLBG",
  "EFTP",
  "PATC",
  "GMTT",
  "RCNN",
  "FMMI",
  "PATG",
  "KTOL",
  "ENTC",
  "KTPA",
  "RCTP",
  "MMEP",
  "LICT",
  "MMTC",
  "ENVA",
  "ENTO",
  "NZTG",
  "KTRI",
  "KTRK",
  "LIMF",
  "LIPQ",
  "SPRU",
  "VOTV",
  "RCSS",
  "LIPH",
  "KTSO",
  "LRTR",
  "YBTL",
  "KTTA",
  "LFOT",
  "KTUL",
  "DTTA",
  "NZAP",
  "KTUP",
  "KTUS",
  "KTUU",
  "KTVC",
  "KTVF",
  "KTVY",
  "KTWF",
  "KTXK",
  "EDDT",
  "KTYR",
  "KTYS",
  "LTCD",
  "UWUU",
  "KUIN",
  "SEQU",
  "ZMUB",
  "ESNU",
  "PAUN",
  "ZWWW",
  "EEKE",
  "VTSB",
  "SAWH",
  "FAUP",
  "UHSS",
  "TLPL",
  "EFVA",
  "PAVA",
  "LBWN",
  "LIPO",
  "LIPZ",
  "SBKP",
  "KVCT",
  "KVCV",
  "LLOV",
  "ENVD",
  "PAVD",
  "KVEL",
  "KVER",
  "FVFA",
  "LEVX",
  "LOWW",
  "KVIS",
  "SBVT",
  "UUWW",
  "LEVC",
  "KVLD",
  "NVVV",
  "KVLL",
  "EYVI",
  "KVPS",
  "TJVQ",
  "MUVR",
  "MMVA",
  "UKCW",
  "VLVT",
  "SLVR",
  "UHWW",
  "FQLC",
  "GVSV",
  "ESMX",
  "NZWU",
  "EIWF",
  "EPWA",
  "PAWB",
  "FYWH",
  "YSWG",
  "WRRW",
  "NZWK",
  "HKNW",
  "NZWF",
  "NZWN",
  "PASK",
  "NZWR",
  "PAWG",
  "KWRL",
  "EPWR",
  "KWST",
  "NZWS",
  "PAWN",
  "ZHHH",
  "KWYS",
  "SBCH",
  "OIMB",
  "EDHI",
  "ZUXC",
  "ZLXY",
  "CYAQ",
  "GOSS",
  "NTGI",
  "ZSAM",
  "SEMC",
  "KXNA",
  "KXNO",
  "MRQP",
  "LEJR",
  "WSSL",
  "YTGM",
  "CYBQ",
  "KXVG",
  "OERY",
  "CYAC",
  "CYAG",
  "PAYA",
  "CYAM",
  "FKKY",
  "CYAT",
  "CYAX",
  "CYAY",
  "CYAZ",
  "KGRK",
  "CYBC",
  "CYBG",
  "CYBK",
  "CYBL",
  "CYBR",
  "CYBT",
  "CYBV",
  "CYBX",
  "CYCB",
  "CYCC",
  "CYCD",
  "CYCG",
  "CYCO",
  "CYCR",
  "CYCS",
  "CYCY",
  "CYDA",
  "CYDF",
  "CYDN",
  "CYDP",
  "CYDQ",
  "CYEG",
  "CYEK",
  "CYER",
  "CYEV",
  "CYFA",
  "CYFB",
  "CYFC",
  "CYFH",
  "CYFO",
  "CYFS",
  "CYGB",
  "CYGH",
  "CYGK",
  "CYGL",
  "CYGO",
  "CYGP",
  "CYGR",
  "CYGT",
  "CYGV",
  "CYGW",
  "CYGX",
  "CYGZ",
  "CYHD",
  "CYHI",
  "CYHK",
  "CYHM",
  "CYHO",
  "CYHR",
  "CYHU",
  "CYHY",
  "CYHZ",
  "CYIF",
  "CYIK",
  "CYIO",
  "KYIP",
  "CYIV",
  "CYJT",
  "CYKA",
  "CYKF",
  "CYKL",
  "KYKM",
  "CYKQ",
  "CYLC",
  "CYLH",
  "CYLL",
  "CYLW",
  "CYMH",
  "CYMM",
  "CYMO",
  "CYMT",
  "CYMX",
  "CYNA",
  "OEYN",
  "CYNC",
  "CYNE",
  "KYNG",
  "CYOC",
  "CYOH",
  "CYOJ",
  "CYOO",
  "CYOP",
  "CYOW",
  "CYPC",
  "CYPE",
  "CYPH",
  "CYPL",
  "CYPM",
  "CYPO",
  "CYPR",
  "CYPW",
  "CYPX",
  "CYQB",
  "CYQD",
  "CYQF",
  "CYQG",
  "CYQK",
  "CYQL",
  "CYQM",
  "CYQN",
  "CYQQ",
  "CYQR",
  "CYQT",
  "CYQU",
  "CYQX",
  "CYQY",
  "CYQZ",
  "CYRA",
  "CYRB",
  "CYRJ",
  "CYRL",
  "CYRS",
  "CYRT",
  "CYSB",
  "CYSH",
  "CYSJ",
  "CYSK",
  "CYSM",
  "CYSR",
  "CYST",
  "CYSY",
  "CZLQ",
  "CYTE",
  "CYTF",
  "CYTH",
  "CYTL",
  "CYTQ",
  "CYTS",
  "CYTZ",
  "CYUB",
  "CYUL",
  "KYUM",
  "CYUT",
  "CYUX",
  "CYUY",
  "CYVB",
  "CYVM",
  "CYVO",
  "CYVP",
  "CYVQ",
  "CYVR",
  "CYVZ",
  "CYWG",
  "CYWH",
  "CYWJ",
  "CYWK",
  "CYWL",
  "CYWP",
  "CYXC",
  "CYXE",
  "CYXH",
  "CYXJ",
  "CYXK",
  "CYXL",
  "CYXN",
  "CYXP",
  "CYXS",
  "CYXT",
  "CYXU",
  "CYXX",
  "CYXY",
  "CYYB",
  "CYYC",
  "CYYD",
  "CYYE",
  "CYYF",
  "CYYG",
  "CYYH",
  "CYYJ",
  "CYYL",
  "CYYQ",
  "CYYR",
  "CYYT",
  "CYYU",
  "CYYY",
  "CYYZ",
  "CYZF",
  "CYZG",
  "CYZP",
  "CYZR",
  "CYZS",
  "CYZT",
  "CYZV",
  "CZAC",
  "LDZD",
  "LDZA",
  "SCVL",
  "LEZG",
  "CZBF",
  "MMZC",
  "SCTC",
  "CZEE",
  "CZEM",
  "CZFM",
  "CZFN",
  "CZGI",
  "MMZH",
  "CZKE",
  "MMZO",
  "CZMT",
  "YNWN",
  "HTZA",
  "SCJO",
  "CZPB",
  "NZQN",
  "LSZH",
  "CZRJ",
  "FMEP",
  "CZSJ",
  "CZSN",
  "NTGY",
  "LGZA",
  "CZTM",
  "KZUN",
  "VLSK",
  "VGSY",
];
